import { isEqual, sortBy } from "lodash-es";

export const getFilterValue = <T>(currentValue: T, defaultValue: T) => {
  if (Array.isArray(currentValue) && Array.isArray(defaultValue)) {
    if (currentValue.length !== defaultValue.length) {
      return currentValue;
    }

    return isEqual([...currentValue].sort(), [...defaultValue].sort())
      ? undefined
      : currentValue;
  }

  return isEqual(currentValue, defaultValue) ? undefined : currentValue;
};

export const getPricesFilterValues = (
  currentValue: [number, number] | undefined,
  defaultValue: [number, number],
) => {
  if (!currentValue || isEqual(sortBy(currentValue), sortBy(defaultValue))) {
    return {
      minPrice: undefined,
      maxPrice: undefined,
    };
  }

  return {
    minPrice: currentValue[0],
    maxPrice: currentValue[1],
  };
};
